import Joi from 'joi';

import { DurationUnitEnum } from '../../../../enums/duration-unit.enum';
import { PricingTierItemTypeEnum } from '../../enums/pricing-tier-item-type.enum';

/**
 * Schema for record validation.
 * @description This schema is used to validate the record properties when creating or updating the record.
 */
export const pricingTierItemSchema = () =>
  Joi.object({
    // Description
    description: Joi.string().allow(null, '').max(256).messages({
      'string.max': 'validations|pricing-tier-item-description|max-length',
    }),

    // Tier type
    type: Joi.string()
      .valid(...Object.values(PricingTierItemTypeEnum))
      .required()
      .messages({
        'any.only': 'validations|pricing-tier-item-type|invalid-value',
      }),

    // Duration unit
    durationUnit: Joi.string()
      .valid(...Object.values(DurationUnitEnum))
      .required()
      .messages({
        'any.required': 'validations|pricing-tier-item-duration-unit|required',
        'any.only': 'validations|pricing-tier-item-duration-unit|invalid-value',
      }),

    // Duration
    duration: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid':
            'validations|pricing-tier-item-duration|cannot-be-null',
        }),
        otherwise: Joi.number().required().messages({
          'any.required': 'validations|pricing-tier-item-duration|required',
          'number.base':
            'validations|pricing-tier-item-duration|must-be-numeric',
        }),
      })
      .prefs({ abortEarly: true }),

    // Price
    price: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|pricing-tier-item-price|cannot-be-null',
        }),
        otherwise: Joi.number().required().messages({
          'any.required': 'validations|pricing-tier-item-price|required',
          'number.base': 'validations|pricing-tier-item-price|must-be-numeric',
        }),
      })
      .prefs({ abortEarly: true }),

    // NOT NULL boolean: omit = leave untouched on update; null treated as unset.
    // Do not .default(false) here — shared create/update schema must preserve omit.
    isStandardDiscountApplied: Joi.boolean().empty(null),
  })
    // Ignore extra fields
    .unknown();
